import React from 'react';
import { pages, app } from "@microsoft/teams-js";
import { getBaseUrl } from '../configVariables';
import i18n from "../i18n";
import { initializeTeamsApp } from '../helpers/teamsApp';

export interface IConfigState {
    url: string;
}

class Configuration extends React.Component<{}, IConfigState> {
    constructor(props: {}) {
        super(props);
        this.state = {
            url: getBaseUrl() + "/messages?locale={locale}"
        }
    }

    public componentDidMount() {
        initializeTeamsApp().then(() => {
            pages.config.registerOnSaveHandler((saveEvent) => {
                const configPromise = pages.config.setConfig ({
                    entityId: "Company_Communicator_App",
                    contentUrl: this.state.url,
                    suggestedDisplayName: "Company Communicator",
                });
                configPromise
                    .then((result) => saveEvent.notifySuccess())
                    .catch((error) => {
                        console.log("Configuration failed: " + error);
                        if (!window.location.search.includes('redirected=true')) {
                            const newUrl = `/errorpage?locale=${i18n.language}?redirected=true`;
                            window.location.href = newUrl;
                        }
                })
                
            });
    
            pages.config.setValidityState(true);
        });
    }

    public render(): JSX.Element {
        return (
            <div className="configContainer">
                <h3>Please click Save to get started.</h3>
            </div>
        );
    }

}

export default Configuration;
